import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, requirePaid = false, requireTmi = false, requireMensGuide = false, requireAdmin = false }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-cream">
        <div className="font-serif-display text-2xl text-sage">Pause…</div>
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (requireAdmin && user.role !== "admin") {
    return <Navigate to="/dashboard" replace />;
  }
  if (requirePaid && !user.has_making_fabulous_access && user.role !== "admin") {
    return <Navigate to="/the-rewired-life" replace />;
  }
  if (requireTmi && !user.has_menopause_invitation_access && user.role !== "admin") {
    return <Navigate to="/the-menopause-invitation" replace />;
  }
  if (requireMensGuide && !user.has_mens_guide_access && user.role !== "admin") {
    return <Navigate to="/a-mans-guide-to-her-menopause" replace />;
  }
  return children;
}
